import {payrollInheritedNode} from '../payroll-utils'
import {AddendCategoryNode} from './addend-category-node'
export function EmployeeNode(e){
  var p = payrollInheritedNode({
    key: 'employee',
    childsKey: 'addendCategories',
    childConstructor: AddendCategoryNode
  },e)

  p.addendCategory = k=>p.addendCategories.find(c=>c.details.id==k)
  p.amountForCategory = k=>{
    var c = p.addendCategory(k)
    if(typeof(c)==='undefined') return null
    return c.value
  }
  p.addendCategoryBreakdown = k=>{
    var c = p.addendCategory(k)
    if(typeof(c)==='undefined') return []
    return c.breakdown
  }
  p.breakdown = (k,v)=>p.addendCategory(k).getBreakdown(v)
  p.breakdownP = (k,v)=>p.addendCategory(k).getBreakdownP(v)
  p.breakdownPd = (k,v)=>p.addendCategory(k).getBreakdownPd(v)
  p.addExtraOrDiscountRequest = (data={amount, date_applied, title, spiff})=>{
    return {
      url: '/extra-or-discount',
      parameters: {
        employee_id: p.details.id,
        employee_payroll_config_id: p.details.employee_payroll_config,
        ...data
      }
    }
  }
  return p
}
